import UserProfileServices from "@/services/UserProfileServices";
import { setAbilities } from "@/libs/acl/setAbilities";

const state = {
  items: [],
  paging: {},
  item: {},
  dol: null,
  rol: "",
  isActive: "",
  userProfile: {},
};

const mutations = {
  SET_USER_ITEMS: (state, payload) => {
    state.items = payload;
  },
  SET_USER_ITEM: (state, payload) => {
    state.item = Object.assign({}, payload);
  },
  SET_USER_DOL: (state, payload) => {
    state.dol = payload;
  },
  SET_USER_ROL: (state, payload) => {
    state.rol = payload;
  },
  SET_USER_IsActive: (state, payload) => {
    state.isActive = payload;
  },
  SET_USER_PROFILE: (state, payload) => {
    state.userProfile = payload;
  },
};

const actions = {
  setUserItems({ commit }, payload) {
    commit("SET_USER_ITEMS", payload);
  },
  setUserItem({ commit }, payload) {
    commit("SET_USER_ITEM", payload);
  },
  setUserDoL({ commit }, payload) {
    commit("SET_USER_DOL", payload);
  },
  setUserRol({ commit }, payload) {
    commit("SET_USER_ROL", payload);
  },
  setUserisActive({ commit }, payload) {
    commit("SET_USER_IsActive", payload);
  },
  setUserProfile({ commit }, payload) {
    commit("SET_USER_PROFILE", {});

    console.log({ UserProfileServices });

    UserProfileServices.getUserProfile()
      .then((res) => {
        if (res.data.status) {
          commit("SET_USER_PROFILE", res.data.data);
          setAbilities(res.data.data.user_modules);
        } else {
          console.log("Failed to get User Profile");
        }
      })
      .catch((err) => {
        console.log("Error in setUserProfile ", err);
      });
  },
};

const getters = {
  userItems: (state) => state.items,
  userPaging: (state) => state.paging,
  userItem: (state) => state.item,
  userDol: (state) => state.dol,
  userRol: (state) => state.rol,
  userisActive: (state) => state.isActive,
  getUserProfile: (state) => state.userProfile,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js